import { variablesGlobales } from "../../configs/variables";
import { calcDescuentoFirmaElectronicaV1 } from "./calcDescuentoFirmaElectronica";
import { calcInteresCorrienteV2 } from "./calcInteresCorriente";


export const calcTotalAPagar = (amount, vencimientoEnDias) => {
    let _firmaElectronicaTotal = 0;
    let tasa = localStorage.getItem("currentInterestRate");
    const interest = calcInteresCorrienteV2(amount, vencimientoEnDias, tasa);
    let firmaElectronica = variablesGlobales.firmaElectronica;
    let dctoFirmaElectronica = calcDescuentoFirmaElectronicaV1(amount, vencimientoEnDias);
    if (dctoFirmaElectronica === firmaElectronica) {
        _firmaElectronicaTotal = firmaElectronica;
    } else {
        _firmaElectronicaTotal = firmaElectronica - dctoFirmaElectronica;
    }
    let total = amount + interest + _firmaElectronicaTotal;
    return total;
}